import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { cache, createQuery, localStorageCache } from '@farfetched/core';
import { signout } from '@features/common';
import * as api from './api';
import type { GetResidentTypesFilterResponse } from './types';

export const ResidentTypesFilterGate = createGate<void>();

const fxGetResidentTypesFilter = createEffect<
  void,
  GetResidentTypesFilterResponse,
  Error
>().use(api.getResidentTypesFilter);

export const residentTypesFilterQuery = createQuery({
  name: 'residentTypesFilter',
  effect: fxGetResidentTypesFilter,
  mapData: ({ result }) =>
    Array.isArray(result.available_filters)
      ? result.available_filters.map((item) => ({
          id: item.type,
          label: item?.title ?? '',
        }))
      : [],
});

cache(residentTypesFilterQuery, {
  adapter: localStorageCache({ maxAge: '5m' }),
  purge: signout,
});

sample({
  clock: ResidentTypesFilterGate.state,
  source: ResidentTypesFilterGate.status,
  filter: (status) => Boolean(status),
  target: residentTypesFilterQuery.start,
});
